import { AppId } from '@inno-tools/container-bridge'
import { useLocation, useNavigate } from 'react-router-dom'
import { useUserContext } from 'shared/hooks/useUserContext'

import { useAvailableApps } from '../hooks/useAvailableApps'
import { FullPageAppTemplate } from '../templates'

const MyOrganizationApp = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useUserContext()
  const { apps } = useAvailableApps()

  return (
    <FullPageAppTemplate
      appId={AppId.MY_ORGANIZATION}
      scope='myorganization'
      envKey={apps[AppId.MY_ORGANIZATION].runtimeEnvKey}
      entryPath='./MyOrganizationApp'
      url={process.env.REACT_APP_MY_ORGANIZATION_APP_DEV_PATH}
      appName={apps[AppId.MY_ORGANIZATION].name}
      appProps={{
        user,
        initialPath: apps[AppId.MY_ORGANIZATION].path,
        onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
          const { pathname } = location

          if (pathname !== nextPathname) {
            navigate(nextPathname)
          }
        }
      }}
    />
  )
}

export { MyOrganizationApp }
